import React, {useState} from 'react';
import {Button, Modal, Row, Spin} from "antd";
import '../modals.css';
import {Redirect} from "react-router-dom";
import i18n from '../../../i18n';

export default function RedirectModal({isShow, setIsShow, text, route, setNeedUpdateDeliveryList = false, title = i18n.t('modals.redirectModal.title')}) {

  const [loading, setLoading] = useState(false);
  const [redirectStatus, setRedirectStatus] = useState(false);

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };


  const redirect = () => {
    setRedirectStatus(true);
  };

  const close = () => {
    setIsShow(false);
    setNeedUpdateDeliveryList(true);
  }

  if (redirectStatus) {
    return (<Redirect to={route} push={true}/>)
  }

  return (
    <Modal
      title={<span className="ant-modal-title">{title}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        close()
      }}
      footer={[
        <Button htmlType="submit" style={bigButtonStyle} key="submit" type="primary" onClick={() => {
          if (route) {
            redirect()
          } else {
            close()
          }
        }}>{route ? 'Перейти' : 'Закрыть'}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{text}</h2>
        </Row>
      </Spin>
    </Modal>
  );
}
